import React, { memo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { withSentryReactRouterRouting } from '@portal/common/services/sentry';

import AuthCallbackScene from '../scenes/AuthCallbackScene';
import ComorbidityExplorerScene from '../scenes/ComorbidityExplorerScene';
import ContactUsScene from '../scenes/ContactUsScene';
import Covid19ExplorerScene from '../scenes/Covid19ExplorerScene';
import DataExplorerScene from '../scenes/DataExplorerScene';
import DataLicenseScene from '../scenes/DataLicenseScene';
import DefinitionsScene from '../scenes/DefinitionsScene';
import DengueScenariosExplorerScene from '../scenes/DengueScenariosExplorerScene';
import EDPExplorerScene from '../scenes/EDPExplorerScene';
import EmailConfirmationScene from '../scenes/EmailConfirmationScene';
import ForgotPasswordScene from '../scenes/ForgotPasswordScene';
import HealthThreatsExplorerScene from '../scenes/HealthThreatsExplorerScene';
import HomeScene from '../scenes/HomeScene';
import MethodologyScene from '../scenes/MethodologyScene';
import MyListScene from '../scenes/MyListScene';
import PermalinkScene from '../scenes/PermalinkScene';
import ProfileScene from '../scenes/ProfileScene';
import RegistrationScene from '../scenes/RegistrationScene';
import ResendSignUpEmailScene from '../scenes/ResendSignUpEmailScene';
import SignInScene from '../scenes/SignInScene';
import SimulationExplorerScene from '../scenes/SimulationExplorerScene';
import SourcesScene from '../scenes/SourcesScene';
import StaffScene from '../scenes/StaffScene';
import TeamScene from '../scenes/TeamScene';
import AnonymousRoute from './AnonymousRoute';
import ProtectedRoute from './ProtectedRoute';
import {
    AUTH_CALLBACK_PATH,
    CONTACT_US_PATH,
    COVID_19_EXPLORER_PATH,
    DATA_EXPLORER_PATH,
    DATA_LICENSE_PATH,
    DEFINITIONS_PATH,
    DENGUE_SCENARIOS_PATH,
    EDP_EXPLORER_PATH,
    EMAIL_CONFIRMATION_PATH,
    FAVORITE_CONTENT_PATH,
    FORGOT_PASSWORD_PATH,
    HEALTH_THREATS_METRICS_PATH,
    HOME_PATH,
    IHME_STAFF_PATH,
    METHODOLOGY_PATH,
    MORBIDITY_EXPLORER_PATH,
    MY_FAVORITES_PATH,
    MY_LISTS_PATH,
    PERMALINK_PATH,
    PROFILE_PATH,
    PUBLIC_LISTS_PATH,
    REGISTRATION_PATH,
    RESEND_SIGN_UP_EMAIL_PATH,
    SIGN_IN_PATH,
    SIMULATION_EXPLORER_PATH,
    SOURCES_PATH,
    TEAM_PATH,
} from './paths';

const SentryRoutes = withSentryReactRouterRouting(Routes);

export default memo(() => (
    <SentryRoutes>
        <Route element={<ProtectedRoute />}>
            {/* Authenticated User Routes */}
            <Route path={HOME_PATH} element={<HomeScene />} />
            <Route path={DEFINITIONS_PATH} element={<DefinitionsScene />} />
            <Route path={SOURCES_PATH} element={<SourcesScene />} />
            <Route
                path={FAVORITE_CONTENT_PATH + MY_LISTS_PATH + '/:listId'}
                element={<MyListScene />}
            />
            <Route
                path={FAVORITE_CONTENT_PATH + PUBLIC_LISTS_PATH + '/:listId'}
                element={<MyListScene />}
            />
            <Route path={DATA_EXPLORER_PATH} element={<DataExplorerScene />} />
            <Route path={COVID_19_EXPLORER_PATH} element={<Covid19ExplorerScene />} />
            <Route path={MORBIDITY_EXPLORER_PATH} element={<ComorbidityExplorerScene />} />
            <Route path={EDP_EXPLORER_PATH} element={<EDPExplorerScene />} />
            <Route path={SIMULATION_EXPLORER_PATH} element={<SimulationExplorerScene />} />
            <Route path={HEALTH_THREATS_METRICS_PATH} element={<HealthThreatsExplorerScene />} />
            <Route path={DENGUE_SCENARIOS_PATH} element={<DengueScenariosExplorerScene />} />
            <Route path={PERMALINK_PATH + '/:hash'} element={<PermalinkScene />} />
            <Route path={METHODOLOGY_PATH} element={<MethodologyScene />} />
            <Route path={IHME_STAFF_PATH} element={<StaffScene />} />
            <Route path={CONTACT_US_PATH} element={<ContactUsScene />} />
            <Route path={DATA_LICENSE_PATH} element={<DataLicenseScene />} />
            <Route path={PROFILE_PATH + ':tabId'} element={<ProfileScene />} />
            <Route path={TEAM_PATH} element={<TeamScene />} />
        </Route>

        <Route element={<AnonymousRoute />}>
            {/* Unauthenticated User Routes */}
            <Route path={SIGN_IN_PATH} element={<SignInScene />} />
            <Route path={EMAIL_CONFIRMATION_PATH} element={<EmailConfirmationScene />} />
            <Route path={REGISTRATION_PATH} element={<RegistrationScene />} />
            <Route path={RESEND_SIGN_UP_EMAIL_PATH} element={<ResendSignUpEmailScene />} />
            <Route path={FORGOT_PASSWORD_PATH} element={<ForgotPasswordScene />} />
            <Route path={AUTH_CALLBACK_PATH} element={<AuthCallbackScene />} />
        </Route>

        <Route path={FAVORITE_CONTENT_PATH} element={<Navigate to={MY_FAVORITES_PATH} />} />
        <Route path="*" element={<Navigate to={HOME_PATH} />} />
    </SentryRoutes>
));
